export default __webpack_public_path__ + "locales/tr/Common.json?hash=c463de61e5be2d4fd7d0ed4115ae17c1";